import { useEffect, useState } from 'react';
import { loadScriptAsync } from '@umu/umu-dom';

/**
 * 动态生成并加载 Script
 * @param paths string[] script src
 * @param condition () => void  条件
 * @returns isLoaded boolean
 * @author Kody
 */
export const useLoadedScript = (paths: string[], condition?: () => boolean) => {
    const [isLoaded, setIsloaded] = useState(false);
    useEffect(() => {
        if (!condition || condition()) {
            loadScriptAsync(paths).then(() => {
                setIsloaded(true);
            });
        }
    }, []);
    return isLoaded;
};
